import { createSelector } from "reselect";
import { AppState } from "../rootReducer";


const getPendingProfile = (state: AppState) => state.profile.pending;
const getProfile = (state: AppState) => state.profile.profile;
const getErrorProfile = (state: AppState) => state.profile.error;

export const getProfileSelector = createSelector(getProfile, (profile) => profile);
export const getProfilePendingSelector = createSelector(getPendingProfile,(pending) => pending);
export const getProfileErrorSelector = createSelector(getErrorProfile, (error) => error);